import src from "IMAGE";
export default { src, width: 2068, height: 279, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AOa1u0jlqrJS3ZylX+OyuErrv8U94KyzUN+jq1jsucBEW7YUr6eguaAAAAAASUVORK5CYII="};
